@import 'vars';
/* stylelint-disable */

:export {
  black: $text;
  text: $text;
  white: $white;
  lightGrey: $light-grey;
  midGrey: $mid-grey;
  darkGrey: $dark-grey;

  lightBlue: $light-blue;
  seeThrough: $see-through;

  success: $success;
  danger: $danger;
  warning: $warning;

  darkBlue: $dark-blue;
  secondary: $secondary;

  pastelBlue: $pastel-blue;
  pastelYellow: $pastel-yellow;
  notificationPastelYellow: $notification-pastel-yellow;
  pastelOrange: $pastel-orange;
  pastelRed: $pastel-red;
  pastelGreen: $pastel-green;

  primary: $primary;

  yellow: $yellow;

  // AI Colours
  aiPrimary: $ai-primary;
  aiSecondary: $ai-secondary;

  // Third Party Colours
  messenger: $messenger;
  whatsapp: $whatsapp;
  instagram: $instagram;
  viber: $viber;
  viberbm: $viberbm;
  telegram: $telegram;
  line: $line;
  rcs: $rcs;
  sms: $sms;
  mms: $mms;
  apple: $apple;
  fallbackColour: $fallback; //have to use c as fallback is keyword

  // Sizes
  overlayWidthLarge: $overlay-large-number;
  overlayWidthSmall: $overlay-small-number;

  fontSizeExtraLarge: $font-size-extra-large;
  fontSizeLarge: $font-size-large;
  fontSizeNormal: $font-size-normal;
  fontSizeSmall: $font-size-small;

  // Weights
  fontWeightBook: $font-weight-book;
  fontWeightMedium: $font-weight-medium;
  fontWeightBold: $font-weight-bold;

  // Breakpoints
  softphoneWidthNumber: $softphone-max-width-number;
  softphoneWidth: $softphone-max-width;

  softphoneSmallWidthNumber: $softphone-small-width-number;
  softphoneSmallWidth: $softphone-small-width;

  desktopMediumScreen: $desktop-medium-screen;

  // Border
  borderRadiusSmall: $border-radius-small;
  borderRadiusmedium: $border-radius-medium;
  borderRadiusLarge: $border-radius-large;
  borderRadiusXLarge: $border-radius-xlarge;
  borderRadiusHuge: $border-radius-huge;
  borderRadiusSquircle: $border-radius-squircle;
  borderRadiusThin: $border-size-thin;
}
